import type { Booking, BookingShootType } from './api';

export const DEFAULT_SHOOT_TYPE_NAME = 'Photography session';

export function formatBookingDuration(minutes: number): string {
  if (minutes <= 90) return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`;
  const hours = Math.floor(minutes / 60);
  const remainder = minutes % 60;
  const hourLabel = `${hours} ${hours === 1 ? 'hour' : 'hours'}`;
  return remainder ? `${hourLabel} ${remainder} minutes` : hourLabel;
}

export function bookingShootTypeName(booking: Pick<Booking, 'shootTypeName'>): string {
  return booking.shootTypeName?.trim() || DEFAULT_SHOOT_TYPE_NAME;
}

export function bookingShootTypes(settings: { shootTypes?: BookingShootType[]; sessionDurationMinutes: number; priceCents?: number }): BookingShootType[] {
  return settings.shootTypes?.length ? settings.shootTypes : [{
    shootTypeId: 'default',
    name: DEFAULT_SHOOT_TYPE_NAME,
    durationMinutes: settings.sessionDurationMinutes,
    priceCents: settings.priceCents
  }];
}
